/* eslint-disable import/prefer-default-export */
import handlePromise from 'utils/handle-promise'

export async function getCertificateService({ uuid, token }) {
  const url = `/api/v1/certificates/${uuid}/`
  const data = await handlePromise(url, {
    method: 'GET',
    headers: { Authorization: token },
  }, true)
  return data
}

export async function createCertificateService({ uuid, token }) {
  const url = `/api/v1/certificates/${uuid}/`
  const data = await handlePromise(url, {
    method: 'PUT',
    headers: { Authorization: token },
  }, true)
  return data
}
